<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="780px"
    :before-close="handleClose"
  >
    <div class="good_dialog">
      <div class="help_item" v-for="item in helpList" :key="item">
        {{ item }}
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    helpList: {
      type: Array,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleClose(done) {
      this.$emit("update:visible", false);
      done();
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.good_dialog {
  .help_item {
    color: #3d3935;
    width: 690px;
    margin: 0 auto 60px;
  }
}
</style>
